<template>
  <div class="container home">
    <fade-transition
      ><modal v-if="$store.state.showTeachers"></modal
    ></fade-transition>
    <div class="columns">
      <spinner v-if="$store.state.isLoading"></spinner>

      <div class="column" v-if="loaded">
        <h2>{{ item.pagetitle }}</h2>
      </div>
      <div class="column has-text-left">
        <button
          class="button save-btn is-info"
          @click="saveSeries(item.id, videoItems)"
        >
          שמור
        </button>
        <router-link to="/" class="button back-btn">חזור</router-link>
      </div>
    </div>

    <div class="columns">
      <div class="series-videos content-scroll column is-half">
        <h3 class="has-text-centered is-size-5">השיעורים בסדרה:</h3>
        <draggable v-model="videos" draggable=".video-item">
          <transition-group tag="div" name="list">
            <video-item
              v-for="(video, index) in videos"
              :key="video.id"
              :item="video"
              :index="index + 1"
            ></video-item>
          </transition-group>
        </draggable>
      </div>
      <div class="content-scroll column is-half has-background-grey-lighter">
        <all-videos></all-videos>
      </div>
    </div>
  </div>
</template>

<script>
import VideoItem from "@/components/videoItem.vue";
import AllVideos from "@/components/allVideos.vue";
import Draggable from "vuedraggable";
import Spinner from "@/components/spinner.vue";
import Modal from "@/components/modal.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    VideoItem,
    AllVideos,
    Draggable,
    Spinner,
    Modal,
    FadeTransition
  },
  data() {
    return {
      loaded: false
    };
  },
  computed: {
    item() {
      let item = this.$store.state.seriesData.filter(
        item => item.id === this.$route.params.id
      );
      return item[0];
    },
    videoItems() {
      let arr = [];
      this.videos.forEach(video => {
        arr.push(video.id);
      });
      return arr.join("||");
    },
    videos: {
      get() {
        return this.$store.state.currentSeriesVideos;
      },
      set(value) {
        this.$store.commit("setSeriesVideos", value);
      }
    },
    videoList() {
      return this.$store.state.videos;
    }
  },
  methods: {
    getList() {
      let ids = this.item.videoItems.split("||");
      let videos = this.$store.state.videos.filter(video => {
        return ids.includes(video.id);
      });
      videos.sort((a, b) => {
        return ids.indexOf(a.id) - ids.indexOf(b.id);
      });
      this.$store.dispatch("getSeriesVideos", videos);
    },
    saveSeries(sid, list) {
      this.$store.dispatch("saveSeries", { sid, list });
    }
  },
  watch: {
    videoList() {
      if (this.videoList.length > 0) {
        this.getList();
        this.$store.commit("setLoadStatus", false);
        this.loaded = true;
      }
    }
  },
  mounted() {
    if (
      this.$store.state.data.teachers &&
      this.$store.state.seriesData.length > 0 &&
      this.$store.state.videos.length > 0
    ) {
      this.getList();
      this.loaded = true;
    } else {
      this.$store.commit("setLoadStatus", true);
    }
  }
};
</script>

<style lang="scss">
.series-videos {
  background-color: white;
  div {
    display: flex;
    flex-wrap: wrap;
  }
}

.save-btn {
  margin-left: 1rem;
  margin-top: 10px;
}

.back-btn {
  margin-top: 10px;
}

//transition
.list-enter-active,
.list-leave-active {
  transition: all 0.3s ease;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>

